import BatchDropdown from "./BatchDropdown";
import UserMultiSelect from "./UserMultiSelect";
import SegmentDropdown from "./SegmentDropdown";

export default function CampaignTargetSelector({
  targetType,
  setTargetType,
  setTargetId,
  setUserIds
}) {

  return (
    <div>
      <h4>Recipients</h4>

      <select
        value={targetType}
        onChange={e => setTargetType(e.target.value)}
      >
        <option value="all">All Students</option>
        <option value="batch">Batch</option>
        <option value="users">Custom Users</option>
        <option value="segment">Segment</option>
      </select>

      {targetType === "batch" && (
        <BatchDropdown onSelect={setTargetId} />
      )}

      {targetType === "users" && (
        <UserMultiSelect onChange={setUserIds} />
      )}

      {targetType === "segment" && (
        <SegmentDropdown onSelect={setTargetId} />
      )}
    </div>
  );
}
